import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import runThemeDiagnostic from './lib/theme-diagnostic';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found in index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Theme diagnostic — collects computed styles after first paint.
// console.log + window.__themeDiagnostic для всех; visible overlay только
// при ?themeDebug=1 в URL search или #themeDebug в hash. Запускается через
// setTimeout(1s) чтобы дать всем стилям и MAX SDK завершить инициализацию.
// Idempotent — повторные вызовы no-op.
setTimeout(runThemeDiagnostic, 1000);
